export const displayTextOrDash = (text) => {
  if (typeof text !== "string") {
    text = text == null ? "" : String(text);
  }
  return text.trim() === "" ? "-" : text;
};

export const normalizeText = (text) => {
  return (text || "").toLowerCase().trim().replace(/\s+/g, "");
};

export const priceFormatPrice = (price, fractionDigits = 0) => {
  if (price == null || isNaN(price)) return "";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(price);
};

export const formatDataWithIcons = (data) => {
  if (!Array.isArray(data)) return {};
  const result = {};
  data.forEach((categoryItem) => {
    const categoryName = categoryItem.category_name;
    const items = categoryItem.personalities || categoryItem.interests || [];
    result[categoryName] = items.map((item) => ({
      key: item.id,
      label: item.name,
      icon: item.icon || "🤟",
    }));
  });
  return result;
};

export const getWebsiteUrl = (url) => {
  if (!url) return "#";
  url = url.trim();

  if (url.startsWith("http://") || url.startsWith("https://")) return url;

  // Remove any leading slashes just in case
  url = url.replace(/^\/+/, "");

  return `https://${url}`;
};

export const mapToSelectOptions = (data = []) =>
  data.map((item) => ({
    value: item.id,
    label: item.name,
  }));

export function getKeyword(item, masterOptions = []) {
  if (item.keyword && item.keyword.trim()) {
    return item.keyword;
  }

  const filterData = item.filter_data || {};

  const parts = Object.entries(filterData).flatMap(([key, value]) => {
    const sourceItem = masterOptions.find((o) => o.id === key);
    if (!sourceItem) return [];

    // Handle tags
    if (sourceItem.type === "tags") {
      const values = Array.isArray(value) ? value : [value];
      return values
        .map((val) => {
          const tag = sourceItem.tags?.find(
            (t) => t.id == val || t.label == val,
          );
          return tag ? tag.label : val;
        })
        .filter(Boolean);
    }

    // Handle slider
    if (sourceItem.type === "slider") {
      if (typeof value === "object") {
        return `${value.min ?? sourceItem.slider.min}-${value.max ?? sourceItem.slider.max}`;
      }
      return `${value}`;
    }

    // Handle select
    if (sourceItem.type === "select") {
      const tag = sourceItem.tags?.find(
        (t) => t.id == value || t.label == value,
      );
      return tag ? tag.label : value;
    }

    return [];
  });

  return parts.filter(Boolean).join(", ");
}
